import React, {Component} from 'react';
import Orders from './Orders';
import {Card, Button, Form, FormField, FormInput} from 'elemental-react16';
import T from 'i18n-react';
import axios from "axios/index";


class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            password: '',
            passwordError: false,
            isLoginSuccess: false
        };
    }

    handlePassword = (e) => {
        this.setState({
            password: e.target.value
        })
    };

    handleLogin = (e) => {
        e.preventDefault();
        if (this.state.password && this.state.password !== '') {
            let _self = this;

            //let urlLogin = 'http://localhost:80/fuorisalone-webapp/public/login.php';
            let urlLogin = '/login.php';

            axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
            axios.defaults.transformRequest = [function (data) {
                let str = [];
                for(let p in data)
                    if (data.hasOwnProperty(p) && data[p]) {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
                    }
                return str.join("&");
            }];
            axios({
                method : 'post',
                url    : urlLogin,
                data   : {password: this.state.password},
            })
                .then((r) => {
                    console.log(r);
                    if (r.data === 'Pass Matched') {
                        _self.setState({
                           isLoginSuccess: true
                        })
                    } else {
                        _self.setState({
                            isLoginSuccess: false,
                            passwordError: true
                        })
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    handleLogout = (e) => {

        e.preventDefault();
        let _self = this;

        axios.get('/logout.php')
            .then(() => {
                _self.setState({
                    isLoginSuccess: false
                })
            })
            .catch((error) => {
                console.log(error);
            });
    };

    checkLoginSession = () => {
        let _self = this;

        !this.state.isLoginSuccess &&
        axios.get('/check-login.php')
            .then((r) => {
                if (r.data === 'Matched') {
                    _self.setState({
                        isLoginSuccess: true
                    })
                } else {
                    _self.setState({
                        isLoginSuccess: false
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    /*formPreventDefault = (e) => {
        e.preventDefault();
    };*/

    componentDidMount() {
        this.checkLoginSession();
    }

    render() {
        return(
                !this.state.isLoginSuccess ?
                    <Card className="login-form">
                        <h2>Administrator Login</h2>
                        <Form onSubmit={this.handleLogin}>
                            <FormField label="Password">
                                <FormInput type="password"
                                           value={this.state.password}
                                           onChange={this.handlePassword} />
                            </FormField>
                            <FormField offsetAbsentLabel>
                                <Button onClick={this.handleLogin}>{T.translate("labels.loginText")}</Button>
                            </FormField>
                        </Form>
                        {
                            this.state.passwordError &&
                            <h6 style={{color: '#FF9A96'}}>Password errata!</h6>
                        }
                    </Card> : <Orders handleLogout={this.handleLogout} />
        )
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/admin/Login.js